import { VEHICLE_TYPES } from '../../constants/constTypes';
import {
    readSafeJsonArray,
    writeSafeJsonArray,
    subscribeStorageKey,
} from './safeStorage';

const STORAGE_KEY = 'compareList';
const EVENT_NAME = 'compareChanged';
export const COMPARE_LIMIT = 4;

const ALLOWED_TYPES = new Set([
    VEHICLE_TYPES.CAR,
    VEHICLE_TYPES.BIKE,
    VEHICLE_TYPES.COMMERCIAL,
]);

let cachedList = null;
let cachedRaw = null;

const invalidateCache = () => {
    cachedList = null;
    cachedRaw = null;
};

const writeAndNotify = (items) => {
    writeSafeJsonArray(STORAGE_KEY, items);
    invalidateCache();
    if (typeof window !== 'undefined') {
        try {
            window.dispatchEvent(new CustomEvent(EVENT_NAME));
        } catch {}
    }
};

const keyOf = (entry) => `${entry.type}:${String(entry.id)}`;

export const getCompareList = () => {
    if (typeof window === 'undefined') return cachedList || [];
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (cachedList && raw === cachedRaw) return cachedList;
    cachedRaw = raw;
    cachedList = readSafeJsonArray(STORAGE_KEY).filter(
        (i) => i && typeof i.id !== 'undefined' && ALLOWED_TYPES.has(i.type),
    );
    return cachedList;
};

export const isInCompare = ({ id, type }) => {
    if (!id || !ALLOWED_TYPES.has(type)) return false;
    const target = keyOf({ id, type });
    return getCompareList().some((i) => keyOf(i) === target);
};

export const addToCompare = ({ id, type }) => {
    if (!id || !ALLOWED_TYPES.has(type)) return false;
    const items = getCompareList();
    const target = keyOf({ id, type });
    if (items.some((i) => keyOf(i) === target)) return true;
    const currentType = items[0]?.type;
    let next = items;
    if (currentType && currentType !== type) {
        next = [];
    }
    if (next.length >= COMPARE_LIMIT) return false;
    next = [...next, { id: String(id), type, ts: Date.now() }];
    writeAndNotify(next);
    return true;
};

export const removeFromCompare = ({ id, type }) => {
    if (!id || !ALLOWED_TYPES.has(type)) return;
    const target = keyOf({ id, type });
    writeAndNotify(getCompareList().filter((i) => keyOf(i) !== target));
};

export const clearCompare = () => writeAndNotify([]);

export const subscribeCompare = (handler) =>
    subscribeStorageKey(STORAGE_KEY, EVENT_NAME, handler);
